import { Navigate, useParams } from 'react-router-dom'

const HowIEatSettings: React.FC = () => {
  const { spaceId } = useParams<{ spaceId: string }>()
  return <Navigate to={`/how-i-eat/${spaceId}?tab=plan`} replace />
}

export default HowIEatSettings
